"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const rebass_1 = require("rebass");
exports.default = () => (React.createElement(rebass_1.Box, { bg: 'purple', color: 'white', px: 2, py: 3 }, "footer"));



// WEBPACK FOOTER //
// ./src/components/footer.tsx